import { Clock, Calendar, ShieldCheck, MessageSquare } from "lucide-react";

const items = [
  {
    icon: Clock,
    title: "30-minute call",
    body: "Focused walkthrough of your market, buy box, and current acquisition pipeline.",
  },
  {
    icon: Calendar,
    title: "We respond in under 1 business day",
    body: "Confirmation email + prep doc within hours of booking. Reschedule freely.",
  },
  {
    icon: MessageSquare,
    title: "What happens after you book",
    body: "1) Confirmation email · 2) 5-min intake form · 3) Strategy call · 4) Custom pipeline plan emailed within 48h.",
  },
  {
    icon: ShieldCheck,
    title: "Zero obligation",
    body: "No contracts, no pitch deck. You leave with a usable plan whether you hire us or not.",
  },
];

const BookingReassurance = () => (
  <section className="border-t border-border bg-muted/40">
    <div className="container-narrow section-padding py-10 md:py-14">
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
        {items.map((i) => (
          <div key={i.title} className="rounded-xl border border-border bg-background p-5">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary/15 text-secondary">
              <i.icon className="h-4 w-4" />
            </div>
            <h3 className="mt-3 font-display text-sm font-bold text-foreground">{i.title}</h3>
            <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">{i.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BookingReassurance;
